import { RefObject, useEffect, useRef, useState } from 'react';

import type { Nullable } from 'chaika-common-types';

interface Data {
    isScrolledFromTop: boolean;
    hasContentBelow: boolean;
    topSentinelRef: RefObject<Nullable<HTMLDivElement>>;
    bottomSentinelRef: RefObject<Nullable<HTMLDivElement>>;
}

export function useScrollShadows(): Data {
    // DOM-узлы нужны только IntersectionObserver — их появление не должно вызывать рендер
    const topSentinelRef = useRef<HTMLDivElement>(null);
    const bottomSentinelRef = useRef<HTMLDivElement>(null);
    const [isTopSentinelVisible, setIsTopSentinelVisible] = useState(true);
    const [isBottomSentinelVisible, setIsBottomSentinelVisible] = useState(true);

    useEffect(() => {
        const topSentinel = topSentinelRef.current;
        const bottomSentinel = bottomSentinelRef.current;

        if (!topSentinel || !bottomSentinel) {
            return;
        }

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.target === topSentinel) {
                    setIsTopSentinelVisible(entry.isIntersecting);
                } else {
                    setIsBottomSentinelVisible(entry.isIntersecting);
                }
            });
        });
        observer.observe(topSentinel);
        observer.observe(bottomSentinel);

        return () => observer.disconnect();
    }, []);

    return {
        isScrolledFromTop: !isTopSentinelVisible,
        hasContentBelow: !isBottomSentinelVisible,
        topSentinelRef,
        bottomSentinelRef,
    };
}
